import { Component, inject, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-success',
  imports: [ CommonModule, MatProgressSpinnerModule, TranslateModule ],
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements AfterViewInit, OnDestroy {
  private router = inject(Router);
  private translate = inject(TranslateService);
  private lang = inject(LanguageService);

  public isLoading = true;
  private removeFns: Array<() => void> = [];

  constructor() {
    const locale = localStorage.getItem('locale') || 'de';
    this.lang.useStored('de');
  }

  ngAfterViewInit() {
    this.setupVideoLoader();
  }

  ngOnDestroy() {
    this.removeFns.forEach(fn => fn());
    this.removeFns = [];
  }

  onStartReserve() {
    this.router.navigate(['rent-duration']);
  }

  onOpenImpressum() {
    this.router.navigate(['impressum']);
  }

  private setupVideoLoader() {
    if (localStorage.getItem('disableVideo') === '1') {
      this.isLoading = false;
      return;
    }

    const video = document.querySelector('video') as HTMLVideoElement | null;
    if (!video) { this.isLoading = false; return; }

    video.muted = true;
    video.setAttribute('playsinline', '');

    const finish = () => { this.isLoading = false; };
    const tryPlay = () => {
      const p = video.play();
      if (p && typeof (p as any).then === 'function') {
        p.then(finish).catch(() => {
          finish();
        });
      } else {
        finish();
      }
    };
    const fallback = setTimeout(finish, 1500);

    video.addEventListener('playing', () => { clearTimeout(fallback); finish(); }, { once: true });
    video.addEventListener('canplay', () => { tryPlay(); }, { once: true });
    video.addEventListener('loadedmetadata', () => { /* Poster ist sichtbar */ });
    video.addEventListener('error', () => { clearTimeout(fallback); finish(); });

    tryPlay();
  }
}
